<template>
  <DashboardLayout class="employee">
    <template #before-content>
      <FilterBar :items="userCards" @updated-filters="setFilters" />
    </template>
    <!-- Cards grid  -->
    <CardsSection
      :title="$t('employee.cards_listing.card_section_title')"
      :items-length="listingCards.length"
    >
      <CardsSectionBlock>
        <!-- block items in grid ⤵ -->
        <CardSingle v-for="card in listingCards" :key="card.id" :card="card" />
      </CardsSectionBlock>
    </CardsSection>
  </DashboardLayout>
</template>

<script>
// Utilities
import { mapState } from 'vuex'
// Components
import FilterBar from 'Ui/FilterBar'
import CardSingle from 'Modules/Card/CardSingle'
import CardsSection from 'Components/CardsSection'
import DashboardLayout from 'Layouts/DashboardLayout'
import CardsSectionBlock from 'Components/CardsSectionBlock'

export default {
  name: 'DashboardTeamCardsListing',
  components: {
    FilterBar,
    CardSingle,
    CardsSection,
    DashboardLayout,
    CardsSectionBlock,
  },
  data() {
    return {
      listingCards: [],
    }
  },
  methods: {
    setFilters(filteredCards) {
      this.listingCards = filteredCards
    },
  },
  computed: {
    ...mapState('cards', ['userCards']),
  },
}
</script>

<style scoped>
.filter-bar {
  position: sticky;
  top: 64px;
  left: 0;
  width: 100%;
  z-index: 6;
}

@media (max-width: 680px) {
  .filter-bar {
    position: fixed;
  }
}
</style>
